import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  id?: string;
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'center',
  id
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'text-center mx-auto items-center' : 'text-left';
  return <div className={`flex flex-col gap-2 max-w-2xl ${alignment}`} data-id="element-257" data-mp="3k204vdujfk8d">
      {eyebrow && <p className="font-display text-xs font-bold uppercase tracking-[0.18em] text-accent" data-id="element-258" data-mp="bmgecml94fx0">
          {eyebrow}
        </p>}
      <h2 id={id} className="font-display text-2xl md:text-3xl font-extrabold uppercase leading-tight text-ink" data-id="element-259" data-mp="1utslwbaeyg0">
        {title}
      </h2>
      {description && <p className="text-base text-ink-muted leading-relaxed" data-id="element-260" data-mp="uj7voqh8gkyf">
          {description}
        </p>}
    </div>;
}